export default __webpack_public_path__ + "static/media/graphic.b517d2fd.jpeg";